import React, { useState, useEffect } from 'react';
import { useDebounceFn } from 'ahooks';

export default function useIsTextOverflow(wrapper: React.RefObject<HTMLElement | null>, props: { text: string }) {
  const { text } = props;

  const [isOverflow, setIsOverflow] = useState(false);

  const updateIsOverflow = () => {
    if (!wrapper.current) return;
    const { scrollWidth, clientWidth } = wrapper.current;
    setIsOverflow(scrollWidth > clientWidth);
  };

  const { run: handleResize } = useDebounceFn(
    () => {
      updateIsOverflow();
    },
    { wait: 600 },
  );

  useEffect(() => {
    updateIsOverflow();
  }, [text]);

  useEffect(() => {
    window.addEventListener('resize', handleResize, false);

    return () => {
      window.removeEventListener('resize', handleResize, false);
    };
  }, []);

  return isOverflow;
}
